import { Badge, Button } from "@jaiho/ui";
import type { GameCatalogueEntry } from "@jaiho/shared";
import "./Sheet.css";
import "./GameDetailSheet.css";

export function GameDetailSheet({ game, onClose }: { game: GameCatalogueEntry; onClose: () => void }) {
  return (
    <div className="jaiho-sheet-backdrop" onClick={onClose}>
      <div className="jaiho-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="jaiho-sheet__handle" />
        <div className={`jaiho-sheet__art jaiho-game-card__art--${game.thumbnailKey}`} />
        <div className="jaiho-sheet__header">
          <div className="jaiho-sheet__title">{game.name}</div>
          <Badge tone="accent">{game.status === "COMING_SOON" ? "Coming Soon" : game.status}</Badge>
        </div>
        <p className="jaiho-sheet__desc">{game.description}</p>
        <div className="jaiho-sheet__meta">
          <div>
            <div className="jaiho-sheet__meta-label">Bet range</div>
            <div className="jaiho-sheet__meta-value">
              {game.minBet.toLocaleString("en-IN")}–{game.maxBet.toLocaleString("en-IN")} credits
            </div>
          </div>
          <div>
            <div className="jaiho-sheet__meta-label">Category</div>
            <div className="jaiho-sheet__meta-value">{game.category === "CASINO" ? "Casino-style" : "Arcade"}</div>
          </div>
        </div>
        <p className="jaiho-sheet__note">
          This game isn't playable yet — it uses virtual, non-redeemable credits only when it launches.
        </p>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
}
